import Vue from "vue";

const file = require("../../public/forms_configuration/bankruptcy/list_of_courts.json");

export function getBankruptcyCourts() {
  // return an array of a bankruptcy courts
  return Array.prototype.concat.apply([], Object.values(file));
}

export function getBankruptcyCourtsNames() {
  // return an array of a bankruptcy courts names
  let all_courts = getBankruptcyCourts();
  return all_courts.map(item => {
    return item.name;
  });
}

export async function getBankruptcyCourtForSelect(province, postal_code, region) {
  // return court from backend based on user's province, postal code and region
  let court_from_backend = null;
  if (Boolean(province) && Boolean(postal_code)) {
    court_from_backend = await Vue.Courts.get_bankruptcy_court_from_backend(
      province,
      postal_code,
      region
    );
    
  }
  return court_from_backend;
}

export function getCourtData(court_name) {
  // get court data based on provided court name if court doesn't exist object with null as every field is returned
  var courts = getBankruptcyCourts();
  for(var i = 0; i < courts.length; i++) {
    if (courts[i].name == court_name) {
      return courts[i];
    }
  }
  return {
    "name": null,
    "zip_code": null,
    "city": null,
    "street": null,
    "home_number": null,
    "website": null,
    "account_number": null
  };
}
